export default "__VITE_ASSET__CwCAHYgb__"